import { render, staticRenderFns } from "./DeviceModel.vue?vue&type=template&id=57ffb500"
import script from "./DeviceModel.vue?vue&type=script&lang=js"
export * from "./DeviceModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports